import { render } from "./EditProdColis.vue?vue&type=template&id=ab5b1262&scoped=true&ts=true"
import script from "./EditProdColis.vue?vue&type=script&lang=ts"
export * from "./EditProdColis.vue?vue&type=script&lang=ts"

import "./EditProdColis.vue?vue&type=style&index=0&id=ab5b1262&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab5b1262"]])

export default __exports__